import { memo } from 'react';

import { SignupSSOTermsInfo } from '~/components/Modals/SignupModal/SignupSSOTermsInfo';

type SignUpModalFooterProps = {
  onLoginClick: () => void;
};

export const SignUpModalFooter = memo(({ onLoginClick }: SignUpModalFooterProps) => {
  return (
    <div className="flex flex-col gap-6">
      <SignupSSOTermsInfo />
      <div className="flex flex-col items-center justify-center">
        <p className="text-center text-14 text-pigeon-600">Already have an account?</p>
        <button
          data-testid="SIGNUP_MODAL_LOGIN_BUTTON"
          className="font-medium text-14 text-jay-500 hover:underline"
          onClick={onLoginClick}
          type="button"
        >
          Log in
        </button>
      </div>
    </div>
  );
});

SignUpModalFooter.displayName = 'SignUpModalFooter';
